import React from "react";
import type { SetorProgressoTv } from "../../../../services/controleProducaoService";
import { AssinaturaLinha } from "./AssinaturaLinha";

export const SetorProgressCard: React.FC<{ setor: SetorProgressoTv }> = ({
  setor,
}) => {
  const completo = setor.pct >= 100 && setor.itensTotal > 0;
  return (
    <article className="flex min-h-0 flex-col rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-sm sm:p-5 lg:p-6">
      <p className="text-sm font-black uppercase tracking-[0.14em] text-yellow-200 sm:text-base lg:text-lg">
        {setor.setorNome}
      </p>
      <div className="mt-2 flex items-end justify-between gap-3">
        <p
          className={`font-black tabular-nums leading-none ${
            completo ? "text-emerald-300" : "text-white"
          } text-5xl sm:text-6xl lg:text-7xl`}
        >
          {setor.pct}
          <span className="text-2xl sm:text-3xl lg:text-4xl">%</span>
        </p>
        <p className="pb-1 text-right text-sm font-semibold tabular-nums opacity-80 sm:text-base lg:text-lg">
          {setor.itensResolvidos}/{setor.itensTotal} itens
        </p>
      </div>
      <div
        className="mt-3 h-3 overflow-hidden rounded-full bg-black/30 sm:h-4"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={setor.pct}
        aria-label={`Progresso de ${setor.setorNome} ${setor.pct}%`}
      >
        <div
          className={`h-full rounded-full transition-[width] duration-500 ${
            completo ? "bg-emerald-400" : "bg-yellow-300"
          }`}
          style={{ width: `${Math.min(100, Math.max(0, setor.pct))}%` }}
        />
      </div>
      <AssinaturaLinha
        label="Produção do setor"
        assinatura={setor.producao}
      />
    </article>
  );
};
